import { api } from '@verifime/api-definition';
import {
  enqueErrorNotification,
  enqueSuccessNotification,
  IdentityDocumentType,
  TDvsErrorDetail,
  TDocumentVerificationStatus,
  TDocumentVerificationStatusActions,
} from '@verifime/components';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export type TDvsData = {
  status?: keyof typeof TDocumentVerificationStatus;
  errors?: {
    errorDetails?: TDvsErrorDetail[];
  };
};

export function useDvsData(customerId: string, documentType: keyof typeof IdentityDocumentType) {
  const [dvsData, setDvsData] = useState<TDvsData | null>(null);
  const router = useRouter();

  // Fetch initial DVS data
  useEffect(() => {
    if (!customerId || !documentType) {
      return;
    }

    api
      .getV1personCustomerIdidentityDocumentDocumentTypeverificationcurrent({
        params: { customerId, documentType },
      })
      .then((res) => setDvsData(res));
  }, [customerId, documentType]);

  // Reset DVS status
  const resetStatus = async (status: keyof TDocumentVerificationStatusActions) => {
    try {
      const res = await api.putV1personCustomerIdidentityDocumentDocumentTypeverificationstatus(
        { status },
        { params: { customerId, documentType } },
      );
      enqueSuccessNotification('The status is set successfully');
      setDvsData(res);
      router.reload();
      return res;
    } catch (err) {
      enqueErrorNotification(err as string);
      throw err;
    }
  };

  // Resubmit document for DVS validation
  const resubmit = async () => {
    try {
      const res = await api.postV1personCustomerIdidentityDocumentDocumentTypeverification(
        undefined,
        { params: { customerId, documentType } },
      );
      enqueSuccessNotification('Re submit successfully.');
      setDvsData(res);
      router.reload();
      return res;
    } catch (err) {
      enqueErrorNotification(err as string);
      throw err;
    }
  };

  return {
    dvsData,
    dvsErrorDetails: dvsData?.errors?.errorDetails,
    status: dvsData?.status,
    resetStatus,
    resubmit,
  };
}
